"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSavedPropertyToLocalStorage = exports.popSavedPropertyFromLocalStorage = exports.readSavedPropertyFromLocalStorage = exports.setRecentlyViewedToLocalStorage = exports.popRecentlyViewedFromLocalStorage = exports.readRecentlyViewedLocalStorage = exports.setCurrencyCookie = exports.hasAuthCookie = exports.popLocalStorage = exports.readLocalStorage = exports.setLocalStorage = exports.readCookie = exports.setCookie = void 0;
var STORAGE_KEY = {
    RECENTLY_VIEW: 'RecentlyViewedNew',
    SAVE_PROPERTIES: 'PropertyBookmark'
};
var getTld = function () {
    var hostname = window.location.hostname;
    if (hostname.indexOf('192') === 0 || hostname.indexOf('127') === 0)
        return hostname;
    if (hostname.indexOf('.') < 0)
        return hostname;
    if (hostname.split('.').length - 1 === 1)
        return hostname;
    return hostname
        .split('.')
        .slice(-2)
        .join('.');
};
exports.setCookie = function (key, value, expiredSec) {
    var tld = getTld();
    document.cookie = key + "=" + value + ";path=/;domain=" + tld + (expiredSec ? ";max-age=" + expiredSec : '');
};
exports.readCookie = function (key) {
    var v = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
    return v ? v[2] : null;
};
exports.setLocalStorage = function (key, value) {
    window.localStorage.setItem(key, value);
};
exports.readLocalStorage = function (key) {
    return window.localStorage.getItem(key);
};
exports.popLocalStorage = function (key) {
    var value = window.localStorage.getItem(key);
    window.localStorage.removeItem(key);
    return value;
};
exports.hasAuthCookie = function () {
    process.env.AUTHTOKEN ? exports.setCookie('Okay.Website', process.env.AUTHTOKEN) : '';
    return exports.readCookie('Okay.Website');
};
exports.setCurrencyCookie = function (currency) {
    exports.setCookie('CurrencyId', currency.key.toString());
    if (process.env.SUPPORTLEGACYCOOKIE) {
        exports.setCookie('CurrencyName', currency.code2.toUpperCase());
    }
};
// Recently Viewed
exports.readRecentlyViewedLocalStorage = function () {
    var savedPropertiesStr = exports.readLocalStorage(STORAGE_KEY.RECENTLY_VIEW);
    var savedProperties = savedPropertiesStr
        ? JSON.parse(savedPropertiesStr)
        : [];
    return savedProperties;
};
exports.popRecentlyViewedFromLocalStorage = function () {
    var savedPropertiesStr = exports.popLocalStorage(STORAGE_KEY.RECENTLY_VIEW);
    var savedProperties = savedPropertiesStr
        ? JSON.parse(savedPropertiesStr)
        : [];
    return savedProperties;
};
exports.setRecentlyViewedToLocalStorage = function (savedItems) {
    exports.setLocalStorage(STORAGE_KEY.RECENTLY_VIEW, JSON.stringify(savedItems));
};
// Saved Properties
exports.readSavedPropertyFromLocalStorage = function () {
    var savedPropertiesStr = exports.readLocalStorage(STORAGE_KEY.SAVE_PROPERTIES);
    var savedProperties = savedPropertiesStr
        ? JSON.parse(savedPropertiesStr)
        : [];
    return savedProperties;
};
exports.popSavedPropertyFromLocalStorage = function () {
    var savedPropertiesStr = exports.popLocalStorage(STORAGE_KEY.SAVE_PROPERTIES);
    var savedProperties = savedPropertiesStr
        ? JSON.parse(savedPropertiesStr)
        : [];
    return savedProperties;
};
exports.setSavedPropertyToLocalStorage = function (savedItems) {
    exports.setLocalStorage(STORAGE_KEY.SAVE_PROPERTIES, JSON.stringify(savedItems));
};
